const RESULT_PATH = '/calculators/birthverse';

export function getVerseResultUrl(date: Date): string {
  const url = new URL(RESULT_PATH, 'https://birthverse.com');
  url.searchParams.set('month', String(date.getMonth() + 1));
  url.searchParams.set('day', String(date.getDate()));
  url.searchParams.set('utm_source', 'birthverse');
  url.searchParams.set('utm_medium', 'share');
  url.searchParams.set('utm_campaign', 'birthday_verse');
  return url.toString();
}

export function getVerseResultDate(search: string): Date | null {
  const params = new URLSearchParams(search);
  const month = params.get('month');
  const day = params.get('day');
  if (!month || !day || !/^\d{1,2}$/.test(month) || !/^\d{1,2}$/.test(day)) return null;
  if (params.getAll('month').length !== 1 || params.getAll('day').length !== 1) return null;
  const date = new Date(2024, Number(month) - 1, Number(day));
  return date.getMonth() === Number(month) - 1 && date.getDate() === Number(day)
    ? date
    : null;
}

export function isSharedVerseVisit(search: string): boolean {
  const params = new URLSearchParams(search);
  return getVerseResultDate(search) !== null
    && params.get('utm_source') === 'birthverse'
    && params.get('utm_medium') === 'share'
    && params.get('utm_campaign') === 'birthday_verse';
}
